import { Component, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Question } from '../question';
import { QuestionsService } from '../questions.service';
import { ListComponent, PopUpService } from '../../core';

@Component({
  selector: 'lms-questions-list',
  templateUrl: './questions-list.component.html',
  styleUrls: ['./questions-list.component.scss']
})
export class QuestionsListComponent implements OnChanges {
  @Input() listId: string;
  @Input() options: any;
  @Output() onListUpdated: EventEmitter<any> = new EventEmitter<any>();
  public defaultOptions: any = { sort: 'name', elementsName: 'questions.label' };
  public listOptions: any;
  @ViewChild(ListComponent, { static: false }) public listComponent: ListComponent;

  questions: Question[];

  constructor(
    public questionsService: QuestionsService,
    public router: Router,
    public translate: TranslateService,
    public popupService: PopUpService
  ) {}

  ngOnChanges() {
    this.listOptions = Object.assign({}, this.defaultOptions, this.options);
  }

  setCollection(collection) {
    this.questions = collection;
    this.onListUpdated.emit(collection);
  }

  deleteQuestion(question) {
    this.popupService
      .confirmDelete({
        title: this.translate.instant('customizations.documents.questions.confirmDelete'),
        text: this.translate.instant('customizations.documents.questions.deleteMessage')
      })
      .then(() => this.questionsService.delete(question.id))
      .then(() => this.listComponent.fetch())
      .catch((err) => {
        if (err !== 'cancel') {
          this.popupService.showError({
            title: this.translate.instant('questions.deleteError'),
            text: err.serverMessage
          });
        }
      });
  }
}
